import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import { useAuthStore } from "@/store/auth";
import { useDatalayerStore } from "@/store/datalayer";

export const useLogout = () => {
  const route = useRoute();
  const router = useRouter();
  const { trackEvent } = useInteractionDoneTracking()

  const { authentificatedFrom } = storeToRefs(useDatalayerStore());
  const { logout } = useAuthStore();

  const logoutAndRedirect = async () => {
    const isMonCompte = route.path.indexOf("/mon-compte") === 0;
    if (isMonCompte) {
      window.scrollTo(0,0);
    }
    await logout();
    if (isMonCompte) {
      await router.replace("/");
    }
    
    trackEvent({
      event: trackingCodes.EVENTS.interactionDone,
      actionGA: authentificatedFrom.value,
      categoryGA: trackingCodes.CATEGORYGA.logout,
      labelGA: "",
      nonInteraction: false
    });
  }

  return {
    logoutAndRedirect
  }
}